module.exports = __webpack_public_path__ + "img/zanwurenhejilu@2x.8bf4e006.png";